var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sport !== undefined)?_c('div',{staticClass:"sport-link"},[_c('div',{staticClass:"label",on:{"click":_vm.toggleDetails}},[_vm._v(_vm._s(_vm.label))])]):_c('div',[_vm._v("-")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8577ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/links/Sport.vue
// module id = null
// module chunks = 